import { tippy } from "@tippyjs/react";
import ReactDOM from "react-dom";
import { AVATAR_CDN } from "constants/constants";
import { setXOffset, setYOffset } from "./spaceDrag";
import { graphicFocus, graphicPersonLocked } from "./spaceSignalling";
import { showLuidOnCircles } from "./spaceTest";
import {
  avatarCircle,
  myCircle,
  myLuid,
  setmyCircle,
  SPACEBOX,
  people,
} from "./spaceVars";
import { getAvatarBackColor, getPersonInitials } from "helpers/randomHelpers";

export function drawOtherPerson({
  luid,
  given_name,
  family_name,
  avatar_key,
  mic,
  screen,
  cam,
  shout,
  focus,
  buzzed,
  locked,
  x,
  y,
  time,
}) {
  window.efs_debug && window.log("Drawing Remote Circle");
  avatarCircle[luid] = document.createElement("div");
  avatarCircle[luid].className = "remoteCircle";
  avatarCircle[luid].setAttribute("id", luid);
  avatarCircle[luid].setAttribute("tabindex", 0);
  SPACEBOX.append(avatarCircle[luid]);
  drawShout(luid, shout);
  graphicFocus(luid, focus);
  drawAvatar(luid, avatar_key, given_name, family_name);
  drawDeviceStatus(luid, mic, screen, cam);
  moveCircle(luid, x, y);
  drawVisible(luid, time);
  drawBuzzed(luid, buzzed);
  graphicPersonLocked(luid, locked);
}
export function drawMe({
  luid,
  given_name,
  family_name,
  avatar_key,
  mic,
  screen,
  cam,
  shout,
  focus,
  locked,
  x,
  y,
}) {
  window.efs_debug && window.log("Drawing me");
  setmyCircle(document.createElement("div"));
  myCircle.className = "myCircle";
  myCircle.setAttribute("id", luid);
  SPACEBOX.append(myCircle);
  avatarCircle[luid] = myCircle;
  setYOffset(y);
  setXOffset(x);
  // debugger;
  drawShout(luid, shout);
  drawFocus(luid, focus);
  drawAvatar(luid, avatar_key, given_name, family_name);
  drawDeviceStatus(luid, mic, screen, cam);
  moveCircle(luid, x, y);
  drawVisible(luid, true);
  graphicPersonLocked(luid, locked);
}

export function drawAvatar(luid, avatar_key, given_name, family_name) {
  if (!avatarCircle[luid]) return;
  if (showLuidOnCircles) {
    let div = document.createElement("div");
    div.innerHTML = luid;
    avatarCircle[luid].append(div);
    return;
  }

  let div = document.createElement("div");
  div.classList.add("initials");
  div.style.backgroundColor = getAvatarBackColor(given_name);
  div.innerHTML = getPersonInitials(given_name, family_name);
  avatarCircle[luid].append(div);
  if (avatar_key) {
    let img = document.createElement("img");
    img.setAttribute("alt", "existing profile");
    img.setAttribute("src", AVATAR_CDN + avatar_key);
    img.setAttribute("onerror", "this.style.display='none'");
    div.append(img);
  }
}
export function drawShout(luid, shout) {
  if (!avatarCircle[luid]) return;
  if (shout) {
    avatarCircle[luid].classList.add("shouting");
  } else {
    avatarCircle[luid].classList.remove("shouting");
  }
}
export function drawFocus(luid, focus) {
  if (!avatarCircle[luid]) return;
  if (focus) {
    avatarCircle[luid].classList.add("focusing");
    if (luid !== myLuid) setClickToRingTippy(luid);
  } else {
    avatarCircle[luid].classList.remove("focusing");
    if (luid !== myLuid) setNormalTippy(luid);
  }
}

export function drawLocked(luid, locked) {
  if (!avatarCircle[luid]) return;
  if (locked) drawLockIcon(avatarCircle[luid]);
  else undrawLockIcon(avatarCircle[luid]);
}

export function drawBuzzed(luid, buzzedValue) {
  if (!avatarCircle[luid]) return;

  let counter = avatarCircle[luid].querySelector(".ring-counter-box");
  if (buzzedValue > 0) {
    if (!counter) counter = drawCounterBox(avatarCircle[luid]);
    counter.querySelector(".count").innerHTML = buzzedValue;
  } else {
    undrawCounterBox(counter);
  }
}

export function drawTalking(luid, value) {
  if (!avatarCircle[luid]) return;
  let contentDivClassList =
    avatarCircle[luid].querySelector(".initials").classList;
  if (value) contentDivClassList.add("talking");
  else contentDivClassList.remove("talking");
}

export function drawVisible(luid, visible) {
  if (!avatarCircle[luid]) return;
  if (visible) {
    avatarCircle[luid].classList.remove("not-visible");
  } else {
    avatarCircle[luid].classList.add("not-visible");
  }
}

export function moveCircle(luid, x, y) {
  if (!avatarCircle[luid]) return;
  avatarCircle[luid].style.transform =
    "translate3d(" + Math.trunc(x) + "px, " + Math.trunc(y) + "px, 0)";
}

export function scaleAllPositions(reduceRatio) {
  for (var luid in people) {
    people[luid].x = reduceRatio * people[luid].x;
    people[luid].y = reduceRatio * people[luid].y;
    people[luid].d2me = reduceRatio * people[luid].d2me;
    moveCircle(luid, people[luid].x, people[luid].y);
  }
}

export function greyOutAll() {
  document.getElementById("remote-media-array").classList.add("greyed-out");
  for (let luid in avatarCircle) {
    if (myLuid !== luid) {
      avatarCircle[luid].classList.add("greyed-out");
      avatarCircle[luid].classList.add("not-visible");
    }
  }
}

export function ungreyOutAll() {
  let elem = document.getElementById("remote-media-array");
  if (elem) {
    elem.classList.remove("greyed-out");
  }
  for (let luid in avatarCircle) {
    if (myLuid !== luid) {
      avatarCircle[luid].classList.remove("greyed-out");
      if (avatarCircle[luid].classList.contains("within-distance")) {
        avatarCircle[luid].classList.remove("not-visible");
        avatarCircle[luid].classList.remove("within-distance");
      } else {
        avatarCircle[luid].classList.add("not-visible");
      }
    }
  }
}

let focusTimer = null;
export function highlightCircle(luid) {
  focusTimer = setTimeout(() => {
    if (avatarCircle[luid]) avatarCircle[luid].focus();
  }, 800);
}
export function unhighlightCircle(luid) {
  clearTimeout(focusTimer);
  document.activeElement.blur();
}

export function drawWithinDistance(luid, withinDistance) {
  if (!avatarCircle[luid]) return;
  if (withinDistance) {
    avatarCircle[luid].classList.add("within-distance");
  } else {
    avatarCircle[luid].classList.remove("within-distance");
  }
}

export function undrawAllWithinDistance() {
  for (let luid in avatarCircle)
    avatarCircle[luid].classList.remove("within-distance");
}

function setNormalTippy(luid) {
  if (!avatarCircle[luid] || !people[luid]) return;
  avatarCircle[luid].style.cursor = null;
  if (avatarCircle[luid].tippyInstance)
    avatarCircle[luid].tippyInstance.destroy();
  avatarCircle[luid].tippyInstance = tippy(avatarCircle[luid], {
    content: `${people[luid].given_name} ${people[luid].family_name}`,
    theme: "inSpace",
    delay: [400, 0],
    hideOnClick: true,
    trigger: "mouseenter focus",
    appendTo: "parent",
  });
}

function setClickToRingTippy(luid) {
  if (!avatarCircle[luid] || !people[luid]) return;
  avatarCircle[luid].style.cursor = "pointer";
  if (avatarCircle[luid].tippyInstance)
    avatarCircle[luid].tippyInstance.destroy();
  avatarCircle[luid].tippyInstance = tippy(avatarCircle[luid], {
    content: `${people[luid].given_name} ${people[luid].family_name} (click to ring)`,
    theme: "inSpace",
    delay: [0, 0],
    hideOnClick: false,
    appendTo: "parent",
  });
}

function drawCounterBox(elem) {
  let div = document.createElement("div");
  let span = document.createElement("span");
  // let icon = document.createElement("span");

  div.classList.add("ring-counter-box");
  span.classList.add("count");
  div.appendChild(span);
  elem.appendChild(div);

  return div;
}
function undrawCounterBox(elem) {
  if (!elem) return;
  // ReactDOM.unmountComponentAtNode(elem.querySelector(".icon"));
  elem.remove();
}

export function drawDeviceStatus(luid, mic, screen, cam) {
  let elem = avatarCircle[luid];
  if (!elem) return;
  let deviceIconContainer = elem.querySelector(".device-icon-container");
  if (!deviceIconContainer) {
    deviceIconContainer = document.createElement("div");
    deviceIconContainer.classList.add("device-icon-container");
    elem.appendChild(deviceIconContainer);
  }

  ReactDOM.render(
    <>
      {cam && (
        <svg
          width="8"
          height="12"
          viewBox="0 0 8 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.60533"
            y="0.60533"
            width="6.78934"
            height="10.7893"
            rx="2.39467"
            fill="#FA544D"
            stroke="black"
            strokeWidth="0.78934"
          />
        </svg>
      )}
      {screen && (
        <svg
          width="8"
          height="12"
          viewBox="0 0 8 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.60533"
            y="0.60533"
            width="6.78934"
            height="10.7893"
            rx="2.39467"
            fill="#FEB700"
            stroke="black"
            strokeWidth="0.78934"
          />
        </svg>
      )}
      {mic && (
        <svg
          width="8"
          height="12"
          viewBox="0 0 8 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.60533"
            y="0.60533"
            width="6.78934"
            height="10.7893"
            rx="2.39467"
            fill="#2BC138"
            stroke="black"
            strokeWidth="0.78934"
          />
        </svg>
      )}
    </>,
    deviceIconContainer
  );
}

export function drawLockIcon(elem) {
  if (elem.querySelector(".lock-icon-container")) return;

  let div = document.createElement("div");
  let icon = document.createElement("span");

  div.classList.add("lock-icon-container");
  icon.classList.add("icon");

  div.appendChild(icon);
  elem.appendChild(div);

  ReactDOM.render(
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2608 7.0211H2.73924C2.04518 7.0211 1.48253 7.58375 1.48253 8.27782V12.9652C1.48253 13.8225 2.17757 14.5176 3.03494 14.5176H9.96506C10.8224 14.5176 11.5175 13.8225 11.5175 12.9652V8.27782C11.5175 7.58375 10.9548 7.0211 10.2608 7.0211Z"
        fill="#929292"
        stroke="black"
        strokeWidth="1.03494"
      />
      <path
        d="M10.1004 8.05593H10.6179V7.53846V5.6C10.6179 3.32598 8.77441 1.48253 6.50039 1.48253C4.22638 1.48253 2.38292 3.32598 2.38292 5.6V7.53846V8.05593H2.90039H10.1004Z"
        fill="#929292"
        stroke="black"
        strokeWidth="1.03494"
      />
      <path
        d="M4.69922 5.64619C4.69922 4.65208 5.50511 3.84619 6.49922 3.84619V3.84619C7.49333 3.84619 8.29922 4.65208 8.29922 5.64619V7.5385H4.69922V5.64619Z"
        fill="black"
      />
    </svg>,
    icon
  );

  return div;
}

export function undrawLockIcon(circle) {
  if (!circle || !circle.querySelector(".icon")) return;

  ReactDOM.unmountComponentAtNode(circle.querySelector(".icon"));
  circle.querySelector(".lock-icon-container").remove();
}

// Maybe have a container div that is moved around
// And ReactDOM.render() inside it for the easier avatar manipulation stuff?
// when moving and people have within distance markers we do that the vanilla way as important styles
